// extracted by mini-css-extract-plugin
export default {"cartList":"Cart_cartList__BttZ0","header":"Cart_header__sJgsB","total":"Cart_total__4i3nq","noItems":"Cart_noItems__2mdGT"};